import { render } from "./ClientTallerOrdenNueva.vue?vue&type=template&id=0938e46e&scoped=true"
import script from "./ClientTallerOrdenNueva.vue?vue&type=script&lang=js"
export * from "./ClientTallerOrdenNueva.vue?vue&type=script&lang=js"

import "./ClientTallerOrdenNueva.vue?vue&type=style&index=0&id=0938e46e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0938e46e"]])

export default __exports__